import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

interface DialogCreateOrderErrorProps {
  onConfirm: () => void;
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  okText?: string | React.ReactNode;
  testId?: string;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        padding: "5px 24px 0 24px",
        height: 48
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 32px",
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    }
  }),
  { name: "DialogConfirmDelete" }
);

const DialogCreateOrderError: React.FC<DialogCreateOrderErrorProps> = ({
  onConfirm,
  open,
  title,
  content,
  okText,
  testId
}) => {
  const classes = useStyles({});
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      className={classes.root}
      data-testid={testId ?? "dialogCreateOrderError"}
    >
      {title ? (
        <DialogTitle>
          <MyTypography variant="h6">{title}</MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      {content ? <DialogContent>{content}</DialogContent> : ""}
      <DialogActions disableSpacing={true}>
        {okText && (
          <Button
            color="primary"
            variant="contained"
            className={classes.btnAction}
            fullWidth={true}
            onClick={onConfirm}
          >
            <MyTypography variant="body1">{okText}</MyTypography>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogCreateOrderError;
